import { Input } from "../uikit";
import styles from "./supportcontacts.module.css";
import Copy from "../img/copy.svg";
import LinkOut from "../img/linkout.svg";
import Card from "./Card";
import { useTranslation } from "react-i18next";
import { EMAIL, TELEGRAM_SUPPORT_BOT_LINK, TELEGRAM_SUPPORT_BOT_NAME } from "../consts";

export default function SupportContacts() {
  const { t, _ } = useTranslation();
  return (
    <Card>
      <div className={styles["input-row"]}>
        <div className={styles["input"]}>
          <Input header={t("Email")} value={EMAIL} />
        </div>
        <div
          onClick={() => {
            navigator.clipboard.writeText(EMAIL);
          }}
          className={styles.icon}
        >
          <img src={Copy} alt="" />
        </div>
      </div>
      <div className={styles["input-row"] + " mb-1"}>
        <div className={styles["input"]}>
          <Input header={t("Telegram bot")} value={TELEGRAM_SUPPORT_BOT_NAME} />
        </div>
        <div
          onClick={() => {
            window.open(TELEGRAM_SUPPORT_BOT_LINK, "_blank");
          }}
          className={styles.icon}
        >
          <img src={LinkOut} alt="" />
        </div>
      </div>
    </Card>
  );
}
